import { Tooltip } from 'react-tippy'
import PageWrapper from './PageWrapper'

const years = ((new Date() - new Date('2023-05-20').getTime()) / (1000 * 60 * 60 * 24 * 365))

function Home() {
  return (
    <>
      <PageWrapper forceReadableWidth>
        <h1>What I Do</h1>
        <div className="div">
          Hey, I am Ruhan.I am a
          {' '}
          <Tooltip
            arrow
            title="Building both front-end and back-end systems."
          >
            <span style={{ color: '#3c71e4' }}>fullstack</span>
          </Tooltip>
          {' '}
          developer.
        </div>
        <div className="div">
          I build websites that are simple to use and
          {' '}
          <Tooltip
            arrow
            title="Simple, clear, friendly, approachable, uncomplicated."
          >
            <span style={{ color: '#3c71e4' }}>user-friendly</span>
          </Tooltip>
          .
        </div>
        <div className="div">
          I try to make things
          {' '}
          <Tooltip
            arrow
            title="Fast Like Flash"
          >
            <span style={{ color: '#3c71e4' }}>super fast</span>
          </Tooltip>
          {' '}
          and
          {' '}
          <Tooltip
            arrow
            title={'beautiful, pretty, and then there\'s you.'}
          >
            <span style={{ color: '#3c71e4' }}>beautiful</span>
          </Tooltip>
          {' '}
          as well.
        </div>
        <div className="div">
          In my free time, I like to read
          {' '}
          <Tooltip
            arrow
            title="I love to read books"
          >
            <span style={{ color: '#3c71e4' }}>books</span>
          </Tooltip>
          {' '}
          a lot and think about my future works, considering what I should do. I
          particularly enjoy learning about something.
        </div>
        <div className="div">
          I have a passion for learning new technologies and staying updated
          with the latest trends in web development.
        </div>
        {/* experience */}
        <h2>Experience</h2>
        <div className="div">
          {/* MAY 20 2023 */}
          With
          {' '}
          <Tooltip arrow title={`${Math.floor(years)} years ${Math.floor((years - Math.floor(years)) * 12)} months`}>
            <span style={{ color: '#3c71e4' }}>
              {years.toFixed(1)}
            </span>
          </Tooltip>
          {' '}
          year of experience, I&apos;m focused on
          learning more and getting better at what I do. I&apos;m determined to
          become even better at it and excited to try new things. Every day,
          I&apos;m eager to grow and face new challenges head-on.
        </div>

        {/* Educational background */}
        <h2>Education</h2>
        <div className="div">
          I am continuing the study on
          {' '}
          <Tooltip
            arrow
            title="Yeah, Average. :3"
          >
            <span style={{ color: '#3c71e4' }}>Computer Science</span>
          </Tooltip>
          .
        </div>
      </PageWrapper>
    </>
  )
}

export default Home
